"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _keycode = _interopRequireDefault(require("keycode"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _Overlay = _interopRequireDefault(require("../Overlay/Overlay"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _useTypeToFocus2 = _interopRequireDefault(require("../utils/useTypeToFocus"));
var _navMenuUtils = require("./_navMenuUtils");
var _NavMenuBar = _interopRequireDefault(require("./NavMenuBar"));
var _NavMenuGroup = _interopRequireDefault(require("./NavMenuGroup"));
var _NavMenuItem = _interopRequireDefault(require("./NavMenuItem"));
var _NavMenuConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-concur_android.css") : void 0);
var _NavMenuConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-concur_default.css") : void 0);
var _NavMenuConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-concur_gateway.css") : void 0);
var _NavMenuConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-concur_ios.css") : void 0);
var _NavMenuSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-sap_fiori_3_dark.css") : void 0);
var _NavMenuSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-sap_fiori_3_hcb.css") : void 0);
var _NavMenuSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-sap_fiori_3_hcw.css") : void 0);
var _NavMenuSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-sap_fiori_3.css") : void 0);
var _NavMenuSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-sap_horizon_dark.css") : void 0);
var _NavMenuSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-sap_horizon_hcb.css") : void 0);
var _NavMenuSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-sap_horizon_hcw.css") : void 0);
var _NavMenuSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenu-sap_horizon.css") : void 0);
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var styles = {
  concur_android: _NavMenuConcur_android.default,
  concur_default: _NavMenuConcur_default.default,
  concur_gateway: _NavMenuConcur_gateway.default,
  concur_ios: _NavMenuConcur_ios.default,
  sap_fiori_3_dark: _NavMenuSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _NavMenuSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _NavMenuSap_fiori_3_hcw.default,
  sap_fiori_3: _NavMenuSap_fiori_.default,
  sap_horizon_dark: _NavMenuSap_horizon_dark.default,
  sap_horizon_hcb: _NavMenuSap_horizon_hcb.default,
  sap_horizon_hcw: _NavMenuSap_horizon_hcw.default,
  sap_horizon: _NavMenuSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-nav-menu';
/**
 * **NavMenu** together with **NavMenu.Group**, **NavMenu.Item**,
 * or **NavMenu.Bar**; is used
 * to present a menu of navigational links. These can be
 * nested to create sub-menus.
 */
var NavMenu = (0, _reactUiTheming.withThemeStyles)(styles)( /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classnames2;
  var _a, _b, _c, _d, _e;
  var addChildProps = (0, _react.useContext)(_AddChildPropsContext.default);
  var _f = addChildProps ? (0, _assign.default)((0, _assign.default)({}, props), addChildProps(NavMenu, props)) : props,
    show = _f.show,
    size = _f.size,
    ariaCurrent = _f.ariaCurrent,
    disabled = _f.disabled,
    buttonContents = _f.buttonContents,
    buttonRef = _f.buttonRef,
    buttonProps = _f.buttonProps,
    children = _f.children,
    classNameMap = _f.classNameMap,
    className = _f.className,
    overlayProps = _f.overlayProps,
    hoverToOpen = _f.hoverToOpen,
    inNavMenuBar = _f.inNavMenuBar,
    menuAriaLabel = _f.menuAriaLabel,
    iconProps = _f.iconProps,
    listProps = _f.listProps,
    maxHeight = _f.maxHeight,
    moveFocusAndOpenNew = _f.moveFocusAndOpenNew,
    onShow = _f.onShow,
    onHide = _f.onHide,
    wrapperProps = __rest(_f, ["show", "size", "ariaCurrent", "disabled", "buttonContents", "buttonRef", "buttonProps", "children", "classNameMap", "className", "overlayProps", "hoverToOpen", "inNavMenuBar", "menuAriaLabel", "iconProps", "listProps", "maxHeight", "moveFocusAndOpenNew", "onShow", "onHide"]);
  var _useState = (0, _react.useState)(show),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var classnames = _bind.default.bind(classNameMap);
  var internalButtonRef = (0, _react.useRef)(null);
  var internalListRef = (0, _react.useRef)(null);
  var classes = classnames("".concat(CSS_BLOCK, "__container"), className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--disabled"), disabled));
  (0, _react.useEffect)(function () {
    if (children) {
      if (isOpen) {
        onShow === null || onShow === void 0 ? void 0 : onShow();
      } else if (isOpen === false) {
        onHide === null || onHide === void 0 ? void 0 : onHide();
      }
    }
  }, [isOpen, children]);
  var handleToggle = function handleToggle() {
    setIsOpen(!isOpen);
  };
  var handleKeyDown = function handleKeyDown(event) {
    var _context;
    if (!disabled && (0, _includes.default)(_context = ['enter', 'space', 'down']).call(_context, (0, _keycode.default)(event))) {
      event.preventDefault();
      setIsOpen(!isOpen);
    }
  };
  var handleMouseEnter = function handleMouseEnter() {
    if (hoverToOpen) {
      setIsOpen(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (hoverToOpen) {
      setIsOpen(false);
    }
  };
  var handleHide = function handleHide() {
    setIsOpen(false);
  };
  var hideAndFocus = function hideAndFocus(focusDirection) {
    var _a, _b;
    handleHide();
    (_b = (_a = internalButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    if (focusDirection === 'left' || focusDirection === 'right') {
      moveFocusAndOpenNew === null || moveFocusAndOpenNew === void 0 ? void 0 : moveFocusAndOpenNew(internalButtonRef.current, focusDirection);
    }
  };
  var passChildProps = function passChildProps(child) {
    if (child.displayName === 'NavMenuItem') {
      return {
        hideMainMenu: hideAndFocus,
        hoverToOpen: hoverToOpen,
        inNavMenuBar: inNavMenuBar
      };
    }
    return {};
  };
  var handlePopperMouseEnter = function handlePopperMouseEnter() {
    if (hoverToOpen) {
      setIsOpen(true);
    }
  };
  var handlePopperMouseLeave = function handlePopperMouseLeave() {
    if (hoverToOpen) {
      setIsOpen(false);
    }
  };
  var _useTypeToFocus = (0, _useTypeToFocus2.default)({
      focusCandidates: (0, _from.default)(((_a = internalListRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role="menuitem"]')) || []),
      keyStrokeTimeout: 50,
      focusMatchingItem: _navMenuUtils.focusMatchingItem
    }),
    handleTypeToFocus = _useTypeToFocus.handleTypeToFocus;
  var menuOverlay = /*#__PURE__*/_react.default.createElement(_Overlay.default, (0, _assign.default)({
    popperPlacement: ['bottom-start', 'bottom-end', 'top-start', 'top-end', 'bottom', 'top', 'auto']
  }, overlayProps, {
    show: isOpen,
    onShow: function onShow() {
      return setIsOpen(true);
    },
    innerDialogClassName: classnames("".concat(CSS_BLOCK, "__inner-dialog")),
    onHide: handleHide,
    onClickOutside: function onClickOutside(event) {
      return (0, _navMenuUtils.handleOutsideClick)(event, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onClickOutside, handleHide, false);
    },
    popperProps: (0, _assign.default)((0, _assign.default)({
      role: 'presentation'
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps), {
      onMouseEnter: (0, _chainFunction.default)(handlePopperMouseEnter, (_b = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _b === void 0 ? void 0 : _b.onMouseEnter),
      onMouseLeave: (0, _chainFunction.default)(handlePopperMouseLeave, (_c = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _c === void 0 ? void 0 : _c.onMouseLeave),
      'data-overflow-flyout': 'true',
      'data-nui-widgets': 'menu-overlay'
    }),
    popperContentProps: (0, _assign.default)((0, _assign.default)({}, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps), {
      className: classnames((_d = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps) === null || _d === void 0 ? void 0 : _d.className, "".concat(CSS_BLOCK, "__overlay")),
      style: (0, _assign.default)({
        maxHeight: maxHeight
      }, (_e = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperContentProps) === null || _e === void 0 ? void 0 : _e.style)
    }),
    targetComponent: /*#__PURE__*/_react.default.createElement(_Button.default, (0, _assign.default)({
      type: "link"
    }, buttonProps, {
      role: inNavMenuBar ? 'menuitem' : undefined,
      size: size,
      disabled: disabled,
      allowFocusOnDisable: disabled,
      "aria-current": !!ariaCurrent || undefined,
      "aria-haspopup": "true",
      "aria-expanded": isOpen,
      className: classnames("".concat(CSS_BLOCK, "__toggle"), buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, (_classnames2 = {}, (0, _defineProperty2.default)(_classnames2, "".concat(CSS_BLOCK, "__toggle--current"), !!ariaCurrent), (0, _defineProperty2.default)(_classnames2, "".concat(CSS_BLOCK, "__toggle--disabled"), !!disabled), _classnames2)),
      innerTextClasses: classnames(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerTextClasses, "".concat(CSS_BLOCK, "__toggle-text")),
      onMouseEnter: (0, _chainFunction.default)(handleMouseEnter, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onMouseEnter),
      onMouseLeave: (0, _chainFunction.default)(handleMouseLeave, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onMouseLeave),
      onClick: (0, _chainFunction.default)(handleToggle, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick),
      onKeyDown: (0, _chainFunction.default)(handleKeyDown, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onKeyDown),
      ref: buttonRef ? (0, _reactMergeRefs.default)([buttonRef, internalButtonRef]) : internalButtonRef
    }), buttonContents, /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _assign.default)({
      ariaHidden: true,
      iconName: "arrow-2-s",
      forceSize: size === 'md' ? 'xs' : 'xs-plus'
    }, iconProps))),
    focusManagerProps: {
      nextKeyCode: _keycode.default.codes.down,
      previousKeyCode: _keycode.default.codes.up,
      trapWithTabbing: true,
      onlyContainedEvents: true,
      useHomeAndEndKeys: true
    }
  }), /*#__PURE__*/_react.default.createElement("ul", (0, _assign.default)({}, listProps, {
    role: "menu",
    className: classnames(CSS_BLOCK, listProps === null || listProps === void 0 ? void 0 : listProps.className),
    "aria-label": menuAriaLabel,
    onKeyDown: (0, _chainFunction.default)(handleTypeToFocus, listProps === null || listProps === void 0 ? void 0 : listProps.onKeyDown),
    ref: (listProps === null || listProps === void 0 ? void 0 : listProps.ref) ? (0, _reactMergeRefs.default)([listProps.ref, internalListRef]) : internalListRef
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: passChildProps
  }, children)));
  return inNavMenuBar ? /*#__PURE__*/_react.default.createElement("li", (0, _assign.default)({}, wrapperProps, {
    role: "none",
    ref: ref,
    className: classes
  }), menuOverlay) : /*#__PURE__*/_react.default.createElement("div", (0, _assign.default)({}, wrapperProps, {
    ref: ref,
    className: classes
  }), menuOverlay);
}));
NavMenu.displayName = 'NavMenu';
NavMenu.Bar = _NavMenuBar.default;
NavMenu.Group = _NavMenuGroup.default;
NavMenu.Item = _NavMenuItem.default;
var _default = NavMenu;
exports.default = _default;